import { render, staticRenderFns } from "./FinalizeOrderForm.vue?vue&type=template&id=c6b07f26&scoped=true&"
import script from "./FinalizeOrderForm.vue?vue&type=script&lang=js&"
export * from "./FinalizeOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./FinalizeOrderForm.vue?vue&type=style&index=0&id=c6b07f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b07f26",
  null
  
)

export default component.exports